import { useMemo } from "react"
import { constants } from "ethers"
import { createContainer } from "unstated-next"
import { getStage, Stage } from "../../constant"
import { PerpRewardVestingFactory, PerpTokenFactory, StakedPerpTokenFactory } from "../../types/contracts"
import { MetaData } from "../metadata"
import { Erc20Factory } from "../../types/contracts/Erc20Factory"
import { Connection } from "container/connection"

export const Contract = createContainer(useContract)

// TODO: Should grab contract address info from metadata config.
// production: https://metadata.perp.exchange/production.json
// staging: https://metadata.perp.exchange/staging.json
const PRODUCTION_CONTRACTS = {
    STAKE_PERP_TOKEN: "0x0f346e19F01471C02485DF1758cfd3d624E399B4",
    PERP_TOKEN: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
    IMMEDIATE_VESTING: "0xc2a9e84D77f4B534F049b593C282c5c91F24808A",
    TIMED_VESTING: "0x49a4B8431Fc24BE4b22Fb07D1683E2c52bC56088",
}
const STAGING_CONTRACTS = {
    STAKE_PERP_TOKEN: "0x05b1d5B3ad20769B3b71b658A1Df2290CD5A2376",
    PERP_TOKEN: "0xaffb148304d38947193785d194972a7d0d9b7f68",
    IMMEDIATE_VESTING: "0x08fa612A94bBEeC0cE0aFD870132ca729848EFe8",
    TIMED_VESTING: "0x8d22F1a9dCe724D8c1B4c688D75f17A2fE2D32df",
}

export const CONTRACT_ADDRESS = ((stage: Stage) =>
    ({
        [Stage.Production]: PRODUCTION_CONTRACTS,
        [Stage.Staging]: STAGING_CONTRACTS,
        [Stage.Development]: STAGING_CONTRACTS,
    }[stage]))(getStage())

function getAddressFromConfig(config: any) {
    const {
        layers: {
            layer1: {
                contracts: { StakedPerpToken, PerpStakingRewardVesting, PerpStakingRewardNoVesting },
                externalContracts: { perp },
            },
        },
    } = config
    return {
        StakePerpToken: StakedPerpToken.address,
        PerpToken: perp,
        ImmediateVesting: PerpStakingRewardNoVesting?.address || "0x08fa612A94bBEeC0cE0aFD870132ca729848EFe8",
        TimedVesting: PerpStakingRewardVesting.address,
    }
}

const defaultContractInstance = {
    isInitialized: false,
    StakePerpToken: null,
    PerpToken: null,
    ImmediateVesting: null,
    TimedVesting: null,
    erc20: null,
}

function useContract() {
    const { config } = MetaData.useContainer()
    const { provider } = Connection.useContainer()

    return useMemo(() => {
        if (!config) {
            return defaultContractInstance
        }
        const contractAddress = getAddressFromConfig(config)
        return {
            isInitialized: true,
            erc20: Erc20Factory.connect(constants.AddressZero, provider),
            StakePerpToken: StakedPerpTokenFactory.connect(contractAddress.StakePerpToken, provider),
            PerpToken: PerpTokenFactory.connect(contractAddress.PerpToken, provider),
            ImmediateVesting: PerpRewardVestingFactory.connect(contractAddress.ImmediateVesting, provider),
            TimedVesting: PerpRewardVestingFactory.connect(contractAddress.TimedVesting, provider),
        }
    }, [config, provider])
}
